/**
 * Per-player nano-id auth. Minted at registration, sent in SMS, used on all
 * /s/:playerKey/* routes. Rides in localStorage so the Apollo link can read
 * it lazily on every request without prop-drilling. PlayerKeyLoader mirrors
 * the URL param into localStorage synchronously during render so the very
 * first Apollo request fires with the header set.
 *
 * Public spectator auth (polf-event-key) lives in the projector package —
 * the player app is player-scoped only.
 */

const PLAYER_STORAGE_KEY = 'polf-player-key'

export const getPlayerKey = (): string | null => {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(PLAYER_STORAGE_KEY)
}

export const setPlayerKey = (key: string): void => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(PLAYER_STORAGE_KEY, key)
}

export const clearPlayerKey = (): void => {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(PLAYER_STORAGE_KEY)
}
